export const FETCH_JOB_DOCUMENTS_REQUEST = 'FETCH_JOB_DOCUMENTS_REQUEST';
export const FETCH_JOB_DOCUMENTS_SUCCESS = 'FETCH_JOB_DOCUMENTS_SUCCESS';
export const FETCH_JOB_DOCUMENTS_FAIL = 'FETCH_JOB_DOCUMENTS_FAIL';

export const CREATE_JOB_DOCUMENT_REQUEST = 'CREATE_JOB_DOCUMENT_REQUEST';
export const CREATE_JOB_DOCUMENT_SUCCESS = 'CREATE_JOB_DOCUMENT_SUCCESS';
export const CREATE_JOB_DOCUMENT_FAIL = 'CREATE_JOB_DOCUMENT_FAIL';

export const UPDATE_JOB_DOCUMENT_REQUEST = 'UPDATE_JOB_DOCUMENT_REQUEST';
export const UPDATE_JOB_DOCUMENT_SUCCESS = 'UPDATE_JOB_DOCUMENT_SUCCESS';
export const UPDATE_JOB_DOCUMENT_FAIL = 'UPDATE_JOB_DOCUMENT_FAIL';

export const DELETE_JOB_DOCUMENT_REQUEST = 'DELETE_JOB_DOCUMENT_REQUEST';
export const DELETE_JOB_DOCUMENT_SUCCESS = 'DELETE_JOB_DOCUMENT_SUCCESS';
export const DELETE_JOB_DOCUMENT_FAIL = 'DELETE_JOB_DOCUMENT_FAIL';
